/* eslint-disable no-param-reassign */
function insertAtCursor(field: HTMLInputElement | HTMLTextAreaElement, text: string) {
  const { value, selectionStart, selectionEnd } = field;

  let nextValue;

  if ((selectionStart || selectionStart === 0) && (selectionEnd || selectionEnd === 0)) {
    nextValue = `${value.substring(0, selectionStart)}${text}${value.substring(
      selectionEnd,
      value.length,
    )}`;

    const nextPosition = selectionStart + text.length;

    field.value = nextValue;
    field.selectionStart = nextPosition;
    field.selectionEnd = nextPosition;
  } else {
    nextValue = `${value}${text}`;

    field.value = nextValue;
  }

  field.focus();

  return nextValue;
}

export default insertAtCursor;
